import { useEffect } from "react";

// The dev frontend (branch `dev`, Testdev1) is served at this host and proxies
// /api/ to the PRODUCTION API. Runtime hostname check (not a build-time env) so
// the exact same build runs on prod and dev; on prod this renders nothing.
const DEV_HOSTNAME = "insights-dev.byacre.com";

export const isDevEnvironment =
  typeof window !== "undefined" && window.location.hostname === DEV_HOSTNAME;

export function DevEnvironmentBanner() {
  useEffect(() => {
    if (isDevEnvironment && !document.title.startsWith("[DEV]")) {
      document.title = `[DEV] ${document.title}`;
    }
  }, []);

  if (!isDevEnvironment) return null;

  // Fixed overlay (the app shell is h-screen, so pushing content down would
  // overflow). pointer-events-none keeps the header underneath clickable.
  return (
    <div
      role="status"
      className="pointer-events-none fixed inset-x-0 top-0 z-[1000] flex justify-center border-t-4 border-amber-500"
    >
      <div className="rounded-b-md bg-amber-500 px-3 py-0.5 text-[11px] font-semibold leading-4 text-black shadow-md">
        DEV · {DEV_HOSTNAME} · connected to LIVE production data — every action here is real
      </div>
    </div>
  );
}
